<template>
  <v-card min-height="550">
    <v-toolbar flat width="100%">
      <v-toolbar-title class="text-capitalize title"
        >{{ $t("animal.performanceInfo.liveweight") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="animalWeights && animalWeights.length > 0"
        @click="showAddEditAnimalWeightDialog('edit')"
        outlined
        right
        height="50"
        width="241"
        color="primary"
      >
        {{ $t("editCurrentRecord") }}
      </v-btn>
      <v-btn
        @click="showAddEditAnimalWeightDialog('add')"
        right
        class="ml-5"
        height="50"
        width="241"
        color="primary"
        type="submit"
      >
        {{ $t("addNewRecord") }}
      </v-btn>
    </v-toolbar>
    <v-row width="100%">
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.performanceInfo.averageDailyGain") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t(
                        "animal.performanceInfo.averageAmountWeightAnimalGainFeedingPeriod"
                      )
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animalWeightData?.averageDailyGain || "Not Specified"
                    }}<span class="ml-2 text-h6 font-weight-light">{{
                      animalWeightData?.averageDailyGainUnit || ""
                    }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="mt-n6 mb-n2 text-overline font-weight-light text-end text--secondary"
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.performanceInfo.liveWeightCurrent") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceMenu.liveWeightTooltip")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animalWeightData?.liveWeight || "Not Specified"
                    }}<span class="ml-2 text-h6 font-weight-light">{{
                      animalWeightData?.liveWeightUnit || ""
                    }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="mt-n6 mb-n2 text-overline font-weight-light text-end text--secondary"
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.performanceInfo.weaningWeight") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("animal.performanceInfo.weightAnimalMeasuredWeaning") }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animalWeightData?.weaningWeight || "Not Specified"
                    }}<span class="ml-2 text-h6 font-weight-light">{{ animalWeightData?.weaningWeightUnit || '' }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="mt-n6 mb-n2 text-overline font-weight-light text-end text--secondary"
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.birthWeight") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("animal.performanceInfo.weightAnimalMeasuredBirth") }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animalWeightData?.birthWeight || "Not Specified"
                    }}<span class="ml-2 text-h6 font-weight-light">{{ animalWeightData?.birthWeightUnit || '' }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="mt-n6 mb-n2 text-overline font-weight-light text-end text--secondary"
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.performanceInfo.yearlingWeight") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.weightYearOldAnimal")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animalWeightData?.yearlingWeight || "Not Specified"
                    }}<span class="ml-2 text-h6 font-weight-light">{{ animalWeightData?.yearlingWeightUnit || ''}}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="mt-n6 mb-n2 text-overline font-weight-light text-end text--secondary"
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
    </v-row>
    <div class="mt-7">
      <span style="font-size: 20px">Animal Weight History</span>
      <v-data-table class="mt-7" :headers="headers" :items="showItems" :items-per-page="20"
        hide-default-footer show-select loading-text="Loading Data...">
        <template #item.createdAt="{ item }">{{ item.createdAt | formatDate }}</template>
        <template #item.averageDailyGain="{ item }">{{ item.averageDailyGain }} {{ item?.averageDailyGainUnit || '' }}</template>
        <template #item.weaningWeight="{ item }">{{ item.weaningWeight }} {{ item?.weaningWeightUnit || '' }}</template>
        <template #item.birthWeight="{ item }">{{ item.birthWeight }} {{ item?.birthWeightUnit || '' }}</template>
        <template #item.liveWeight="{ item }">{{ item.liveWeight }} {{ item?.liveWeightUnit || '' }}</template>
        <template #item.yearlingWeight="{ item }">{{ item.yearlingWeight }} {{ item?.yearlingWeightUnit || '' }}</template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-icon class="mr-2" @click="editHistory(item)">
              mdi-pencil
            </v-icon>
            <v-icon color="red" @click="deleteHistory(item)">
              mdi-delete
            </v-icon>
          </div>
        </template>
        <template v-slot:footer></template>
      </v-data-table>
    </div>
    <AddEditWeightHistory
      @closeDialog="closeDialog"
      v-if="showAddEditHistoryDialog"
      :dialogI="showAddEditHistoryDialog"
      :animalWeightItem="animalWeightItem"
      @onUpdate="onUpdate"
    />
    <AddEditWeight
      @closeDialog="closeDialog"
      v-if="showAddEditDialog"
      :dialogI="showAddEditDialog"
      :animalWeightItem="animalWeightItem"
      @onUpdate="onUpdate"
    />
    <DeletePopup
      :dialogI="showDeleteDialog"
      v-if="showDeleteDialog"
      @delete="onDelete"
      @closeDialog="closeDeleteDialog"
    />
  </v-card>
</template>
<script>
import AddEditWeightHistory from "./AddEditWeightHistory.vue";
import AddEditWeight from "./AddEditWeight.vue";
import gql from "graphql-tag";
import DeletePopup from "../DeletePopup.vue";

export default {
  apollo: {
    animalWeights: {
      query: gql`
        query AnimalWeightRecordHistories($animalId: Int!) {
          animalWeightRecordHistories(animalId: $animalId) {
            id
            averageDailyGain: average_daily_gain
            averageDailyGainUnit: average_daily_gain_unit
            weaningWeight: weaning_weight
            weaningWeightUnit: weaning_weight_unit
            birthWeight: birth_weight
            birthWeightUnit: birth_weight_unit
            liveWeight: live_weight
            liveWeightUnit: live_weight_unit
            yearlingWeight: yearling_weight
            yearlingWeightUnit: yearling_weight_unit
            createdAt
          }
        }
      `,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.animalWeightData = data.animalWeightRecordHistories[0] || null;
        }
      },
      update: (data) => data.animalWeightRecordHistories,
      error: (err) =>
        this.$notify({
          title: "Error loading Animal Weight Histories!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },
  },
  data() {
    return {
      showAddEditDialog: false,
      showAddEditHistoryDialog: false,
      showDeleteDialog: false,
      animalWeightItem: null,
      headers: [
       {
          text: "Date",
          align: "center",
          sortable: true,
          value: "createdAt"
        },
        {
          text: "Average Daily Gain",
          align: "start",
          sortable: true,
          value: "averageDailyGain",
        },
        {
          text: "Live Weight (Current)",
          align: "start",
          sortable: true,
          value: "liveWeight",
        },
        {
          text: "Weaning Weight",
          align: "start",
          sortable: true,
          value: "weaningWeight",
        },
        {
          text: "Birth Weight",
          align: "start",
          sortable: true,
          value: "birthWeight",
        },
        {
          text: "Yearling Weight",
          align: "start",
          sortable: true,
          value: "yearlingWeight",
        },
        { text: "", value: "actions", sortable: false, class: "d-flex" },
      ],
      animalWeightData: {},
      animalWeights: [],
    };
  },
  computed: {
    showItems() {
      let showData = [...this.animalWeights];
      showData.shift();
      return showData;
    },
  },
  methods: {
    closeDialog() {
      this.showAddEditDialog = false;
      this.showAddEditHistoryDialog = false;
      this.animalWeightItem = null;
    },
    showAddEditAnimalWeightDialog(action) {
      if (action == "edit") {
        this.animalWeightItem = this.animalWeightData;
      } else {
        this.animalWeightItem = null;
      }
      this.showAddEditDialog = true;
    },
    async onUpdate() {
      await this.$apollo.queries.animalWeights.refetch();
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
      this.animalWeightItem = null;
    },
    editHistory(item) {
      this.animalWeightItem = item;
      this.showAddEditHistoryDialog = true;
    },
    deleteHistory(item) {
      this.animalWeightItem = item;
      this.showDeleteDialog = true;
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async onDelete() {
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation deleteAnimalWeightRecord(
              $data: UpdateAnimalWeightRecordInput!
            ) {
              deleteAnimalWeightRecord(updateAnimalWeightRecord: $data)
            }
          `,
          variables: {
            data: {
              id: parseInt(this.animalWeightItem.id),
            },
          },
        })
        .then(async (res) => {
          this.$notify({
            title: `History deleted successfully`,
            text: res.message,
            type: "success",
            position: "top right",
          });

          this.showDeleteDialog = false;
          this.deleteItem = null;
          this.onUpdate();
        });
    },
  },
  components: { AddEditWeightHistory, DeletePopup, AddEditWeight },
};
</script>
